function stringifyReason(value) {
  if (value == null || value === '') return '';
  if (typeof value === 'string') return value.trim();
  if (typeof value === 'number' || typeof value === 'boolean') return String(value);
  if (Array.isArray(value)) {
    return value.map(stringifyReason).filter(Boolean).join(', ');
  }
  if (typeof value === 'object') {
    return (
      stringifyReason(value.message) ||
      stringifyReason(value.reason) ||
      stringifyReason(value.description) ||
      stringifyReason(value.error) ||
      stringifyReason(value.details) ||
      JSON.stringify(value)
    );
  }
  return String(value);
}

export function isRejectedTemplate(template = {}) {
  return String(template?.status ?? '').toUpperCase() === 'REJECTED';
}

export function getRejectionReason(template = {}) {
  const candidates = [
    template?.failed_reason,
    template?.rejected_reason,
    template?.rejection_reason,
    template?.reject_reason,
    template?.reason,
    template?.response?.failed_reason,
    template?.response?.reason,
    template?.response?.rejected_reason,
  ];

  for (const candidate of candidates) {
    const text = stringifyReason(candidate);
    if (text) return text;
  }

  return '';
}
